/**
 * A base object to extend which is evented and statable.
 * Provides event functionality (on, off, trigger) and state management.
 * @public
 * @constructor Functional
 * @return {Object} An instance of EventEmitter with event and state capabilities
 */

mm.EventEmitter = function () {
  "use strict"

  var self = {
      states: {},
      _events: {}
    },
    _currentState

  /**
   * Register an event listener
   * @param {String} events Space-separated event names
   * @param {Function} callback The callback function
   * @return {Object} self
   */
  self.on = function (events, callback) {
    if (!events || !callback) return self

    var eventNames = events.split(/\s+/)
    for (var i = 0; i < eventNames.length; i++) {
      var eventName = eventNames[i]
      if (!self._events[eventName]) {
        self._events[eventName] = []
      }
      self._events[eventName].push(callback)
    }
    return self
  }

  /**
   * Remove event listeners
   * @param {String} events Space-separated event names
   * @param {Function} callback The callback function to remove (optional)
   * @return {Object} self
   */
  self.off = function (events, callback) {
    if (!events) {
      self._events = {}
      return self
    }

    var eventNames = events.split(/\s+/)
    for (var i = 0; i < eventNames.length; i++) {
      var eventName = eventNames[i]
      if (!self._events[eventName]) continue

      if (!callback) {
        delete self._events[eventName]
      } else {
        var callbacks = self._events[eventName]
        for (var j = callbacks.length - 1; j >= 0; j--) {
          if (callbacks[j] === callback) {
            callbacks.splice(j, 1)
          }
        }
        if (callbacks.length === 0) {
          delete self._events[eventName]
        }
      }
    }
    return self
  }

  /**
   * Trigger an event
   * @param {String} eventName The event name
   * @param {...*} args Arguments to pass to callbacks
   * @return {Object} self
   */
  self.trigger = function (eventName) {
    if (!self._events[eventName]) return self

    var args = Array.prototype.slice.call(arguments, 1)
    var callbacks = self._events[eventName].slice() // Create a copy to avoid issues if callbacks modify the array

    for (var i = 0; i < callbacks.length; i++) {
      callbacks[i].apply(self, args)
    }
    return self
  }

  /**
   * Checks the current state of this instance
   * @param  {String} state The state to check against
   * @return {Boolean}      The result of comparing states
   */
  self.isState = function (state) {
    return state === _currentState ? true : false
  }

  /**
   * Sets the current state of the instance, and checks which callbacks to call
   * @public
   * @param  {String} state The new state to apply to this instance
   */
  self.setState = function (state) {
    var offCallback,
      onCallback,
      newState = state,
      args = Array.prototype.slice.call(arguments, 1)

    if (newState !== _currentState) {
      onCallback =
        self.states[
          "on" +
            newState.replace(/^\w/, function (s) {
              return s.toUpperCase()
            })
        ]
      if (typeof _currentState !== "undefined") {
        offCallback =
          self.states[
            "off" +
              _currentState.replace(/^\w/, function (s) {
                return s.toUpperCase()
              })
          ]
      }
      _currentState = newState
      if (typeof onCallback !== "undefined") {
        onCallback.apply(self, args)
      }
      if (typeof offCallback !== "undefined") {
        offCallback.apply()
      }
    }
  }

  return self
}
